var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-switch", {
        attrs: {
          disabled: _vm.authDisabled,
          "active-value": 1,
          "inactive-value": 0,
          "active-color": "#ec1c1c",
          "inactive-color": "#f0f0f0"
        },
        on: { change: _vm.changeFn },
        model: {
          value: _vm.data.useFileAuditFlag,
          callback: function($$v) {
            _vm.$set(_vm.data, "useFileAuditFlag", $$v)
          },
          expression: "data.useFileAuditFlag"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f1a2d06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f1a2d06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/corp-comps/switch-btn.vue
// module id = i6d1
// module chunks = 7 30 55 56 92